'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../../libs/colors');

exports.default = {
  default: {
    width: '100%',
    height: '100%',
    borderStyle: 'dashed',
    borderWidth: '2px',
    borderColor: _colors.grey,
    borderRadius: '5px',
    overflow: 'hidden',
    color: _colors.darkGrey,
    cursor: 'pointer',
    WebkitUserSelect: 'none',
    userSelect: 'none',
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  active: {
    background: _colors.white
  },
  accept: {
    background: _colors.white,
    borderColor: _colors.green,
    color: _colors.green
  },
  reject: {
    background: _colors.white,
    borderColor: _colors.red,
    color: _colors.red
  }
};